export class ImportColumnMap {
    public column: string;
    public value: string;

    constructor(column: string, value: string) {
        this.column = column;
        this.value = value;
    }
}
